import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingHomeFeaturesPage: FlowPage = {
  slug: () => 'home-features',
  title: () => 'Does your home have any of these features?',
  isEnabled,
  autoAdvance: () => true,
  subtitle: () =>
    'This helps us understand how your home’s features compare to similar properties.',
  questions: () => [
    {
      key: 'home.home_features',
      type: 'multi_select',
      options: [
        {
          label: 'Vaulted ceilings',
          value: 'vaulted_ceilings',
        },
        {
          label: 'Skylight',
          value: 'skylight',
        },
        {
          label: 'Fireplace',
          value: 'fireplace',
        },
        {
          label: 'Curb appeal',
          value: 'curb_appeal',
        },
      ],
      showNoneOfTheAbove: true,
    },
  ],
};

export default longboardingHomeFeaturesPage;
